export default __webpack_public_path__ + "static/kompetenzen-76119f4324cbf61f0e1ec8fbb1c73687.webp";